/* @flow */

import type { CombinedReducers } from '../../../reducers';
import type { Dispatch } from '../../../types/types';
import type { NetgemApiEmitterType, RequestResponseMethodDefinitionType } from '../emitter';
import type { BO_RESPONSE_WITH_ETAG } from './types/common';

import { REDUX_MSG_REQUEST_BO_PURCHASE_LIST } from '../../constants';
import getRequestDetails from './helpers/requestCommon';
import { BO_API_PURCHASE_LIST } from './types/common';

const sendPurchaseListRequest: (distributorId: string, signal?: AbortSignal) => RequestResponseMethodDefinitionType =
  (distributorId, signal) =>
  (dispatch: Dispatch, getState: () => CombinedReducers, NetgemApiEmitter: NetgemApiEmitterType): Promise<BO_RESPONSE_WITH_ETAG> => {
    const {
      ui: {
        purchaseListETagCache: { [distributorId]: eTag },
      },
    } = getState();

    // Object 'requestDetails' contains 'headers', 'method' and 'uri' parameters
    const requestDetails = getRequestDetails(getState, distributorId, BO_API_PURCHASE_LIST);

    return NetgemApiEmitter.emit(REDUX_MSG_REQUEST_BO_PURCHASE_LIST, {
      ...requestDetails,
      eTag,
      signal,
    });
  };

export default sendPurchaseListRequest;
